import React, { useState } from "react";
import "../assets/css/responsive.css";
import "../assets/css/style.css";
import "../assets/css/hamburger.css";

import MentionsLegal from "../components/mentionLegal/mentionsLegal";

const MentionLegal = () => {
  return (
    <div className="main">
      <MentionsLegal />
    </div>
  );
};

export default MentionLegal;